import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MFAService {
  private http = inject(HttpClient);
  private apiServer = environment.authenticationServer;

  public API = {
    GetQRCode: () => this.getQRCode(),
    RefreshMFA: () => this.refreshMFA(),
    RefreshMFAByUser: (userId: string | number) => this.refreshMFAByUser(userId),
    VerifyQRCode: (mfatoken: string) => this.verifyQRCode(mfatoken)
  };

  private getQRCode(): Promise<any> {
    return firstValueFrom(this.http.get<any>(`${this.apiServer}/api/user/mfa/code`));
  }

  private refreshMFA(): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiServer}/api/user/mfa/refresh`, {}));
  }

  private refreshMFAByUser(user_id: string | number): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiServer}/api/user/mfa/refresh/user/${user_id}`, {}));
  }

  private verifyQRCode(mfatoken: string): Promise<any> {
    return firstValueFrom(this.http.post<any>(`${this.apiServer}/api/user/mfa/configure/verify?mfatoken=${encodeURIComponent(mfatoken)}`, {}));
  }
}
